"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitReport = exports.submitDraftReport = exports.savePlanTaskNew = exports.savePlanTask = exports.savePlanTarget = exports.querySRList = exports.queryAllEmpList = exports.newStore = exports.getTimeList = exports.getStoreBaseInfo = exports.getSRList = exports.getRouteByStoreNew = exports.getRoute = exports.getReportDetail = exports.getPlanTaskList = exports.getPlanTaskAllocatedInfo = exports.getPlanStoreList = exports.getPlanInfo = exports.getListSecondlyAdvancedVisitStore = exports.getListRecommendAdvancedVisitStore = exports.getListAdvancedVisitStore = exports.getDraftReport = exports.getDailyNumList = exports.getAllocateTime = exports.getAiRoute = exports.finishOtherPlan = exports.exportExcel = exports.delPlanTask = exports.default = exports.checkinPlan = exports.changePlanTaskDate = void 0;
var _request = _interopRequireDefault(require("@/http/request"));
/** package */

// (PLAN_TASK_1)计划任务列表 ID：mzWL7g2l
var getPlanTaskList = exports.getPlanTaskList = function getPlanTaskList(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/pageList",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// (PLAN_TASK_2)保存计划任务 ID：58pNRoz3
var savePlanTask = exports.savePlanTask = function savePlanTask(data) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/save",
    method: 'post',
    data: data
  });
};
var savePlanTaskNew = exports.savePlanTaskNew = function savePlanTaskNew(data) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/new/save",
    method: 'post',
    data: data
  });
};

// (PLAN_TASK_3)删除计划任务 ID：YX05Z7zx
var delPlanTask = exports.delPlanTask = function delPlanTask(data) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/del",
    method: 'post',
    data: data
  });
};

// (PLAN_TASK_4)获取计划任务详情 ID：nzdbvq8j
var getPlanInfo = exports.getPlanInfo = function getPlanInfo(data) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/detail",
    method: 'post',
    data: data
  });
};

// (PLAN_TASK_5)为计划任务添加目标 ID：e24kyxzL
var savePlanTarget = exports.savePlanTarget = function savePlanTarget(data) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/saveTarget",
    method: 'post',
    data: data
  });
};

// (PLAN_TASK_6)添加访店计划时获取门店列表 ID：VXEk532v
var getPlanStoreList = exports.getPlanStoreList = function getPlanStoreList(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/storeList",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// (PLAN_TASK_7)按日期区间获取每日计划任务数量 ID：r2jlm1XG
var getDailyNumList = exports.getDailyNumList = function getDailyNumList(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/dailyNum",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// (PLAN_TASK_8)按时间区间和门店列表，自动分配时间
var getAllocateTime = exports.getAllocateTime = function getAllocateTime(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/allocateTime",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var getAiRoute = exports.getAiRoute = function getAiRoute(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/ai/store/route",
    method: 'post',
    data: data,
    cancelToken: cancelToken,
    hideError: true
  });
};

// (PLAN_TASK_9)按计划日期获取百度地图路线
var getRoute = exports.getRoute = function getRoute(data) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/route",
    method: 'post',
    data: data
  });
};
var getRouteByStoreNew = exports.getRouteByStoreNew = function getRouteByStoreNew(data) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/new/routeByStore",
    method: 'post',
    data: data
  });
};

// (PLAN_TASK_11)签到
var checkinPlan = exports.checkinPlan = function checkinPlan(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/checkin",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// (PLAN_TASK_12)提交访店报告
var submitReport = exports.submitReport = function submitReport(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/submit",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// (PLAN_TASK_13)提交访店报告草稿
var submitDraftReport = exports.submitDraftReport = function submitDraftReport(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/submitDraft",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// (PLAN_TASK_15)完成其它类型任务（除访店外）
var finishOtherPlan = exports.finishOtherPlan = function finishOtherPlan(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/finish",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// (PLAN_TASK_16)门店开卡
var newStore = exports.newStore = function newStore(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/newStore",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// (PLAN_TASK_18)获取访店报告草稿
var getDraftReport = exports.getDraftReport = function getDraftReport(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/getSubmitDraft",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// (PLAN_TASK_19)按日期获取已占用时间（计划|任务）
var getTimeList = exports.getTimeList = function getTimeList(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/timeList",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// (PLAN_TASK_20)获取访店报告详情
var getReportDetail = exports.getReportDetail = function getReportDetail(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/reportDetail",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// (PLAN_TASK_21)获取访店报告门店基础信息(编写访店报告使用)
var getStoreBaseInfo = exports.getStoreBaseInfo = function getStoreBaseInfo(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/storeBaseInfo",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 导出计划
var exportExcel = exports.exportExcel = function exportExcel(data) {
  return (0, _request.default)({
    module: 'CORE',
    url: '/protected/app/planTask/export',
    method: 'post',
    data: data,
    responseType: 'blob'
  });
};

// 获取SR List
var getSRList = exports.getSRList = function getSRList() {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/bizOrgInfo/querySrByAsm",
    method: 'post'
  });
};

// SR模糊查询
var querySRList = exports.querySRList = function querySRList(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/newProduct/search/srAndAsm",
    method: 'post',
    data: data
  });
};
var queryAllEmpList = exports.queryAllEmpList = function queryAllEmpList(data) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/app/home/newProduct/search/allEmp",
    method: 'post',
    data: data
  });
};
var getListAdvancedVisitStore = exports.getListAdvancedVisitStore = function getListAdvancedVisitStore(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/retailorStoreInfo/listAdvancedVisitStore",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var getListSecondlyAdvancedVisitStore = exports.getListSecondlyAdvancedVisitStore = function getListSecondlyAdvancedVisitStore(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/retailorStoreInfo/listSecondlyAdvancedVisitStore",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var getListRecommendAdvancedVisitStore = exports.getListRecommendAdvancedVisitStore = function getListRecommendAdvancedVisitStore(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/retailorStoreInfo/listRecommendAdvancedVisitStore",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var changePlanTaskDate = exports.changePlanTaskDate = function changePlanTaskDate(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/changePlanTaskDate",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var getPlanTaskAllocatedInfo = exports.getPlanTaskAllocatedInfo = function getPlanTaskAllocatedInfo(data) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/app/planTask/task/allocated/list",
    method: 'post',
    data: data
  });
};
var _default = exports.default = {
  getPlanTaskList: getPlanTaskList,
  savePlanTask: savePlanTask,
  delPlanTask: delPlanTask,
  getPlanInfo: getPlanInfo,
  savePlanTarget: savePlanTarget,
  getPlanStoreList: getPlanStoreList,
  getDailyNumList: getDailyNumList,
  getAllocateTime: getAllocateTime,
  checkinPlan: checkinPlan,
  submitReport: submitReport,
  submitDraftReport: submitDraftReport,
  finishOtherPlan: finishOtherPlan,
  newStore: newStore,
  getDraftReport: getDraftReport,
  getTimeList: getTimeList,
  getReportDetail: getReportDetail,
  getStoreBaseInfo: getStoreBaseInfo,
  exportExcel: exportExcel,
  getSRList: getSRList,
  getListAdvancedVisitStore: getListAdvancedVisitStore,
  getListSecondlyAdvancedVisitStore: getListSecondlyAdvancedVisitStore,
  getListRecommendAdvancedVisitStore: getListRecommendAdvancedVisitStore
};